import script from "./expertOpinionList.vue?vue&type=script&setup=true&lang=js"
export * from "./expertOpinionList.vue?vue&type=script&setup=true&lang=js"

import "./expertOpinionList.vue?vue&type=style&index=0&id=b869f30c&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b869f30c"]])

export default __exports__